import type { ICPQCart } from 'api/cart/types';
import type { IAssemblyGroupItem } from 'containers/AssemblyGroupStorage/types';

export const mapSingleAssemblyToEvent = (cart: ICPQCart): ICPQCart => cart;

export const mapAssemblyGroupToEvent = (items: IAssemblyGroupItem[]): ICPQCart[] => (
  items.map(({ cartData }) => {
    // Strip FE-added sessionId from the persisted cartData before emitting it
    // as an event payload (we don't want to leak session ids to the parent).
    const cart = { ...cartData };
    delete (cart as { sessionId?: unknown }).sessionId;
    return cart;
  })
);
